"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchNonce = exports.fetchFullMempoolTxs = exports.fetchMempoolTxs = exports.broadcastTx = exports.fetchFullTxs = exports.fetchTxs = exports.fetchBlockHeight = exports.fetchEstimatedFees = exports.fetchBalances = void 0;
const network_1 = __importDefault(require("@ledgerhq/live-network/network"));
const env_1 = require("../../../../env");
const getStacksURL = (path) => {
    const baseUrl = (0, env_1.getEnv)("API_STACKS_ENDPOINT");
    if (!baseUrl)
        throw new Error("API base URL not available");
    return `${baseUrl}${path ? path : ""}`;
};
const fetch = (path) => __awaiter(void 0, void 0, void 0, function* () {
    const url = getStacksURL(path);
    // We force data to this way as network func is not using the correct param type. Changing that func will generate errors in other implementations
    const opts = {
        method: "GET",
        url,
    };
    const rawResponse = yield (0, network_1.default)(opts);
    // We force data to this way as network func is not using the correct param type. Changing that func will generate errors in other implementations
    const { data } = rawResponse;
    return data;
});
const send = (path, data) => __awaiter(void 0, void 0, void 0, function* () {
    const url = getStacksURL(path);
    const opts = {
        method: "POST",
        url,
        data: JSON.stringify(data),
        headers: { "Content-Type": "application/json" },
    };
    const rawResponse = yield (0, network_1.default)(opts);
    // We force data to this way as network func is not using generics. Changing that func will generate errors in other implementations
    const { data: responseData } = rawResponse;
    return responseData;
});
const sendRaw = (path, data) => __awaiter(void 0, void 0, void 0, function* () {
    const url = getStacksURL(path);
    const opts = {
        method: "POST",
        url,
        data,
        headers: { "Content-Type": "application/octet-stream" },
    };
    const rawResponse = yield (0, network_1.default)(opts);
    // We force data to this way as network func is not using generics. Changing that func will generate errors in other implementations
    const { data: responseData } = rawResponse;
    return responseData;
});
const fetchBalances = (addr) => __awaiter(void 0, void 0, void 0, function* () {
    const data = yield fetch(`/extended/v1/address/${addr}/stx`);
    return data; // TODO Validate if the response fits this interface
});
exports.fetchBalances = fetchBalances;
const fetchEstimatedFees = (request) => __awaiter(void 0, void 0, void 0, function* () {
    const feeRate = yield send(`/v2/fees/transfer`, request);
    return feeRate; // TODO Validate if the response fits this interface
});
exports.fetchEstimatedFees = fetchEstimatedFees;
const fetchBlockHeight = () => __awaiter(void 0, void 0, void 0, function* () {
    const data = yield fetch("/extended/v1/status");
    return data; // TODO Validate if the response fits this interface
});
exports.fetchBlockHeight = fetchBlockHeight;
const fetchTxs = (addr, offset = 0) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield fetch(`/extended/v1/address/${addr}/transactions_with_transfers?offset=${offset}`);
    return response; // TODO Validate if the response fits this interface
});
exports.fetchTxs = fetchTxs;
const fetchFullTxs = (addr) => __awaiter(void 0, void 0, void 0, function* () {
    let qty, offset = 0;
    let txs = [];
    do {
        const { results, total, limit } = yield (0, exports.fetchTxs)(addr, offset);
        txs = txs.concat(results);
        offset += limit;
        qty = total;
    } while (offset < qty);
    return txs; // TODO Validate if the response fits this interface
});
exports.fetchFullTxs = fetchFullTxs;
const broadcastTx = (message) => __awaiter(void 0, void 0, void 0, function* () {
    let response = yield sendRaw(`/v2/transactions`, message);
    if (response != "")
        response = `0x${response}`;
    return response; // TODO Validate if the response fits this interface
});
exports.broadcastTx = broadcastTx;
const fetchMempoolTxs = (addr, offset = 0) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield fetch(`/extended/v1/tx/mempool?sender_address=${addr}&offset=${offset}`);
    return response; // TODO Validate if the response fits this interface
});
exports.fetchMempoolTxs = fetchMempoolTxs;
const fetchFullMempoolTxs = (addr) => __awaiter(void 0, void 0, void 0, function* () {
    let qty, offset = 0;
    let txs = [];
    do {
        const { results, total, limit } = yield (0, exports.fetchMempoolTxs)(addr, offset);
        txs = txs.concat(results);
        offset += limit;
        qty = total;
    } while (offset < qty);
    return txs; // TODO Validate if the response fits this interface
});
exports.fetchFullMempoolTxs = fetchFullMempoolTxs;
const fetchNonce = (addr) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield fetch(`/extended/v1/address/${addr}/nonces`);
    return response; // TODO Validate if the response fits this interface
});
exports.fetchNonce = fetchNonce;
//# sourceMappingURL=api.js.map